import apiClient from './apiClient';

export const contratsAPI = {
  cases: {
    list: (params) => apiClient.get('/contrats/cases/', { params }),
    get: (id) => apiClient.get(`/contrats/cases/${id}/`),
    create: (data) => apiClient.post('/contrats/cases/', data),
    update: (id, data) => apiClient.put(`/contrats/cases/${id}/`, data),
    delete: (id) => apiClient.delete(`/contrats/cases/${id}/`),
  },
  contrats: {
    list: (params) => apiClient.get('/contrats/contrats/', { params }),
    get: (id) => apiClient.get(`/contrats/contrats/${id}/`),
    create: (data) => apiClient.post('/contrats/contrats/', data),
    update: (id, data) => apiClient.put(`/contrats/contrats/${id}/`, data),
    delete: (id) => apiClient.delete(`/contrats/contrats/${id}/`),
  },
  locations: {
    list: (params) => apiClient.get('/contrats/locations/', { params }),
    get: (id) => apiClient.get(`/contrats/locations/${id}/`),
    create: (data) => apiClient.post('/contrats/locations/', data),
    update: (id, data) => apiClient.put(`/contrats/locations/${id}/`, data),
    delete: (id) => apiClient.delete(`/contrats/locations/${id}/`),
  },
  abonnements: {
    list: (params) => apiClient.get('/contrats/abonnements/', { params }),
    get: (id) => apiClient.get(`/contrats/abonnements/${id}/`),
    create: (data) => apiClient.post('/contrats/abonnements/', data),
    update: (id, data) => apiClient.put(`/contrats/abonnements/${id}/`, data),
    delete: (id) => apiClient.delete(`/contrats/abonnements/${id}/`),
  },
  vehicules: {
    list: (params) => apiClient.get('/contrats/vehicules/', { params }),
    get: (id) => apiClient.get(`/contrats/vehicules/${id}/`),
    create: (data) => apiClient.post('/contrats/vehicules/', data),
    update: (id, data) => apiClient.put(`/contrats/vehicules/${id}/`, data),
    delete: (id) => apiClient.delete(`/contrats/vehicules/${id}/`),
  },
  avenants: {
    list: (params) => apiClient.get('/contrats/avenants/', { params }),
    get: (id) => apiClient.get(`/contrats/avenants/${id}/`),
    create: (data) => apiClient.post('/contrats/avenants/', data),
    update: (id, data) => apiClient.put(`/contrats/avenants/${id}/`, data),
    delete: (id) => apiClient.delete(`/contrats/avenants/${id}/`),
  },
  renouvellements: {
    list: (params) => apiClient.get('/contrats/renouvellements/', { params }),
    get: (id) => apiClient.get(`/contrats/renouvellements/${id}/`),
    create: (data) => apiClient.post('/contrats/renouvellements/', data),
    update: (id, data) => apiClient.put(`/contrats/renouvellements/${id}/`, data),
    delete: (id) => apiClient.delete(`/contrats/renouvellements/${id}/`),
  },
  resiliations: {
    list: (params) => apiClient.get('/contrats/resiliations/', { params }),
    get: (id) => apiClient.get(`/contrats/resiliations/${id}/`),
    create: (data) => apiClient.post('/contrats/resiliations/', data),
    update: (id, data) => apiClient.put(`/contrats/resiliations/${id}/`, data),
    delete: (id) => apiClient.delete(`/contrats/resiliations/${id}/`),
  },
  echeances: {
    list: (params) => apiClient.get('/contrats/echeances/', { params }),
    get: (id) => apiClient.get(`/contrats/echeances/${id}/`),
    create: (data) => apiClient.post('/contrats/echeances/', data),
    update: (id, data) => apiClient.put(`/contrats/echeances/${id}/`, data),
    delete: (id) => apiClient.delete(`/contrats/echeances/${id}/`),
  },
};
